import { useMutation } from '@apollo/client/react';
import { Center, IconButton, SimpleGrid, Spinner } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoUserMatch } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import { useCallback } from 'react';
import { RiThumbDownFill, RiThumbDownLine, RiThumbUpFill, RiThumbUpLine } from 'react-icons/ri';
type UserMatchRatingButtonsProps = {
  userMatch: ScoUserMatch;
};
export const UserMatchRatingButtons = (props: UserMatchRatingButtonsProps) => {
  const {
    currentUser
  } = useCurrentUser();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const ratingKey = currentUser?.userId == props.userMatch.searchingUserId ? 'ratingBySearchingUser' : 'ratingByTargetUser';
  const [upsertUserMatch, upsertUserMatchMutation] = useMutation(gql`
    mutation ($input: UpsertUserMatchInput!) {
      upsertUserMatch(input: $input) {
        userMatch {
          ${UserMatchRatingButtons.fragments.ScoUserMatch()}
        }
      }
    }
  `);
  const submitRating = useCallback((rating: number) => {
    upsertUserMatch({
      variables: {
        input: {
          userMatchId: props.userMatch.userMatchId,
          [ratingKey]: rating
        }
      }
    });
  }, [props.userMatch.userMatchId, ratingKey]);
  if (!currentUser) {
    return <Center padding={'1em'}>
        <Spinner />
      </Center>;
  }
  return <SimpleGrid columns={2} gap={2} width={'full'}>
      <IconButton aria-label={'Up Vote'} borderColor={props.userMatch[ratingKey] > 0 ? 'cta' : 'colorPalette.border'} color={props.userMatch[ratingKey] > 0 ? 'black' : 'colorPalette.fg'} size={'sm'} variant={props.userMatch[ratingKey] > 0 ? 'cta' : 'outline'} width={'full'} _hover={{
      borderColor: props.userMatch[ratingKey] > 0 ? 'cta' : 'colorPalette.border'
    }} onClick={() => submitRating(1)}>
        {props.userMatch[ratingKey] > 0 ? <RiThumbUpFill size={16} /> : <RiThumbUpLine size={16} />}
      </IconButton>
      <IconButton aria-label={'Down Vote'} borderColor={props.userMatch[ratingKey] < 0 ? 'cta' : 'colorPalette.border'} color={props.userMatch[ratingKey] < 0 ? 'black' : 'colorPalette.fg'} size={'sm'} variant={props.userMatch[ratingKey] < 0 ? 'cta' : 'outline'} width={'full'} _hover={{
      borderColor: props.userMatch[ratingKey] < 0 ? 'cta' : 'colorPalette.border'
    }} onClick={() => submitRating(-1)}>
        {props.userMatch[ratingKey] < 0 ? <RiThumbDownFill size={16} /> : <RiThumbDownLine size={16} />}
      </IconButton>
    </SimpleGrid>;
};
UserMatchRatingButtons.fragments = {
  ScoUserMatch: () => gql`
    fragment _ on ScoUserMatch {
      id
      userMatchId
      targetUserId
      searchingUserId
      ratingBySearchingUser
      ratingByTargetUser
      ratingNoteBySearchingUser
      ratingNoteByTargetUser
    }
  `
};